<span class="font-medium-title-large">
  {{ type === 'file' ? 'Datei hochladen' : 'Link hinzufügen' }}
</span>

<form [formGroup]="form" class="flex-c gap-24 w-full" (ngSubmit)="submit()">
  @if (type === 'file') {
    <div class="input-simple">
      <div class="input-label">Datei*</div>
      <input
        #fileInput
        class="hidden-file-input"
        type="file"
        [accept]="''"
        (change)="onFileSelected($event)" />
      <button
        type="button"
        class="inwi-icon-text-button-medium-primary"
        (click)="triggerFileSelect()">
        <div class="button-content">
          <i class="fa-regular fa-paperclip-vertical button-icon"></i>
          <div class="button-text">Datei auswählen</div>
        </div>
      </button>
      @if (!selectedFile) {
        <span class="font-regular-body-small">Bitte Datei auswählen.</span>
      } @else {
        <span class="font-regular-body-small">{{ selectedFile.name }}</span>
      }
    </div>
  } @else {
    <div class="input-simple">
      <div class="input-label">
        Titel des Links{{ fieldRequired(form.get('linkTitle')) ? '*' : '' }}
      </div>
      <input class="input-field" formControlName="linkTitle" type="text" />
      <app-error-message
        [formField]="form.get('linkTitle')"></app-error-message>
    </div>
    <div class="input-simple">
      <div class="input-label">
        URL des Links{{ fieldRequired(form.get('linkUrl')) ? '*' : '' }}
      </div>
      <input class="input-field" formControlName="linkUrl" type="text" />
      <app-error-message [formField]="form.get('linkUrl')"></app-error-message>
    </div>
  }

  <div class="input-simple">
    <div class="input-label">Tags*</div>
    <app-tag-selector
      [selectedTags]="selectedTags"
      (selectedTagsChange)="selectedTagsChange($event)"></app-tag-selector>
  </div>

  <div class="input-select">
    <div class="input-label">Seminare*</div>
    <p-multiSelect
      [options]="seminarOptions"
      formControlName="seminarIds"
      appendTo="body"
      optionLabel="title"
      optionValue="id"
      placeholder="Seminare auswählen">
      <ng-template let-seminar pTemplate="item">
        <div class="flex align-items-center">
          <div>{{ seminar.title }}</div>
          @if (seminar.dates && seminar.dates.length > 0) {
            <span class="font-regular-body-medium text-secondary">
              {{ getSeminarDateString(seminar) }}
            </span>
          }
          @if (seminar.isDraft) {
            <span class="is-draft-tag"> Entwurf</span>
          }
        </div>
      </ng-template>
    </p-multiSelect>
  </div>

  <div class="flex-r gap-16 justify-center">
    <button
      type="button"
      class="inwi-text-button-large-secondary flex-1-0-0"
      (click)="closeDialog()">
      <div class="button-content"><div class="button-text">Abbrechen</div></div>
    </button>
    <button
      type="submit"
      class="inwi-text-button-large-primary flex-1-0-0"
      [disabled]="form.invalid || (type === 'file' && !selectedFile)">
      <div class="button-content"><div class="button-text">Speichern</div></div>
    </button>
  </div>
</form>
